import Navbar from './components/Navbar';
import Hero from './components/Hero';
import UpcomingEvents from './components/UpcomingEvents';
import WhatWeOffer from './components/WhatWeOffer';
import LocationMap from './components/LocationMap';
import Footer from './components/Footer';
import SEOHead from '../../components/base/SEOHead';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL;

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        "url": siteUrl,
        "name": "King Square Club",
        "description": "Benin City's premier luxury nightclub",
        "potentialAction": {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": `${siteUrl}/?s={search_term_string}`
          },
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "NightClub",
        "@id": `${siteUrl}/#nightclub`,
        "name": "King Square Club",
        "description": "Benin City's premier luxury nightclub offering exclusive VIP experiences, world-class entertainment, and unforgettable nights. Open Friday-Sunday, 11PM-5AM.",
        "url": siteUrl,
        "telephone": "+2349039844951",
        "priceRange": "₦₦₦",
        "currenciesAccepted": "NGN",
        "paymentAccepted": "Cash, Bank Transfer",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "148 Airport Rd",
          "addressLocality": "Benin City",
          "postalCode": "300102",
          "addressRegion": "Edo",
          "addressCountry": "NG"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "6.3350",
          "longitude": "5.6037"
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Friday", "Saturday", "Sunday"],
            "opens": "23:00",
            "closes": "05:00"
          }
        ],
        "image": "https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/a34b1e0ab002dc04c0156491411f9278.jpeg",
        "logo": "https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/d426ab47bdf058797dc3f28b72cc35c0.jpeg",
        "sameAs": [
          "https://instagram.com/kingsquareclub",
          "https://snapchat.com/add/kingsquareclub",
          "https://tiktok.com/@kingsquareclub",
          "https://wa.me/2349039844951"
        ],
        "hasMap": "https://maps.google.com/?q=148+Airport+Rd+Benin+City+Edo+Nigeria",
        "servesCuisine": "Bar & Lounge",
        "amenityFeature": [
          { "@type": "LocationFeatureSpecification", "name": "VIP Tables", "value": true },
          { "@type": "LocationFeatureSpecification", "name": "Bottle Service", "value": true },
          { "@type": "LocationFeatureSpecification", "name": "Live DJ", "value": true },
          { "@type": "LocationFeatureSpecification", "name": "Dance Floor", "value": true }
        ]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What are King Square Club's opening hours?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "King Square Club is open Friday, Saturday, and Sunday from 11:00 PM to 5:00 AM."
            }
          },
          {
            "@type": "Question",
            "name": "How do I book a VIP table at King Square Club?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "You can reserve a VIP table by filling out the reservation form on our Contact page, calling +2349039844951, or messaging us on WhatsApp at 09039844951. We recommend booking at least 2 days in advance."
            }
          },
          {
            "@type": "Question",
            "name": "What is the dress code at King Square Club?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "King Square Club enforces a High Class and Dashing dress code. No slippers or shorts for men, and no slippers for ladies."
            }
          },
          {
            "@type": "Question",
            "name": "Where is King Square Club located?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "King Square Club is located at 148 Airport Rd, Benin City 300102, Edo State, Nigeria."
            }
          },
          {
            "@type": "Question",
            "name": "What is the VIP table pricing at King Square Club?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Gold Table reservations are ₦1,000,000 and Silver Table reservations are ₦500,000."
            }
          }
        ]
      }
    ]
  };

  return (
    <div className="min-h-screen bg-black">
      <SEOHead
        title="King Square Club Benin City | Luxury Nightclub & VIP Experience"
        description="Benin City's premier luxury nightclub offering exclusive VIP experiences, world-class entertainment, and unforgettable nights. Open Friday-Sunday, 11PM-5AM."
        keywords="King Square Club, Benin City nightclub, luxury nightclub Edo, VIP nightclub Nigeria, premium entertainment Benin, nightlife Benin City, exclusive club Nigeria"
        canonical={siteUrl}
        ogTitle="King Square Club - Benin City's Premier Luxury Nightclub"
        ogDescription="Experience the ultimate luxury nightlife at King Square Club. Exclusive VIP tables, world-class entertainment, and unforgettable nights in Benin City."
        ogImage="https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/a34b1e0ab002dc04c0156491411f9278.jpeg"
        ogType="website"
        jsonLd={jsonLd}
      />
      <Navbar />
      <Hero />
      <UpcomingEvents />
      <WhatWeOffer />
      <LocationMap />
      <Footer />
    </div>
  );
}
